import React from 'react';
import { ListFieldSection } from '../../../../Layout';
import { Field, TextOutput } from '../../../../Core';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from '../../../Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { useSelector } from 'react-redux';

let BsEnIsoResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const containsDissolvedSalt = useSelector(createWorksheetSelector!('Preparation.ContainsDissolvedSalt'));

  return (
    <>
      <WorksheetsResultsMessagesSection />
      <ListFieldSection visible={!containsDissolvedSalt}>
        <Field input={<TextOutput />} name="Results.MoistureContentPercent" />
      </ListFieldSection>
      <ListFieldSection visible={containsDissolvedSalt}>
        <Field input={<TextOutput />} name="Results.MoistureContentPercent" />
        <Field input={<TextOutput />} name="Results.FluidContent" />
      </ListFieldSection>
    </>
  );
};

BsEnIsoResultsSection = withInjectedProps(BsEnIsoResultsSection);

export { BsEnIsoResultsSection };
export default BsEnIsoResultsSection;
